module.exports = __webpack_public_path__ + "static/3-2df5b664416b7424eff973d0cf02cdf7.jpg";